import React, { useState, useEffect } from "react";
import { withRouter, Link } from 'react-router-dom';

import StyleFabricCategoryComponent from './StyleFabricCategoryComponent';
import VideoLayoutComponent from './VideoLayoutComponent';
import GnbLayoutComponent from './GnbLayoutComponent';
import ContactUsPopupContainer from '../popup/ContactUsPopupContainer';
import * as AppData from '../../../../data/App.data';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}


const MAIN_IMG_LIST = [
    `/imgs/Main_page_1.png`,
    `/imgs/About_TCE_1.png`,
    `/imgs/Styles&Fabric_1.png`,
    `/imgs/Stories&News_1.png`,
    `/imgs/New_Materials&Production_1.png`,
];

const VIDEOS = {
    'main': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/main_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/main_2_repeat.mp4'
    ],
    'about': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/about_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/about_2_repeat.mp4'
    ],
    'style-fabric': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/style_fabric_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/style_fabric_2_repeat.mp4',
    ],
    'style-fabric-detail': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/style_fabric_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/style_fabric_2_repeat.mp4',
    ],
    'stories-news': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/stories_news_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/stories_news_2_repeat.mp4'
    ],
    'story': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/stories_news_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/stories_news_2_repeat.mp4'
    ],
    'news': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/stories_news_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/stories_news_2_repeat.mp4'
    ],
    'new-material-production': [
        'https://d3rsisxi85dvzl.cloudfront.net/lq/new_materials-production_1.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/new_materials-production_2.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/new_materials-production_3.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/new_materials-production_4.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/new_materials-production_5.mp4',
        'https://d3rsisxi85dvzl.cloudfront.net/lq/new_materials-production_6.mp4',
    ]
}


const LayoutComponent = props => {
    const { children, isTest, containerClassName } = props;
    const [menuIdx, setMenuIdx] = useState(0);
    const [mainImageUrl, setMainImageUrl] = useState(0);
    const [selectedCategoryCode, setSelectedCategoryCode] = useState('WOMEN');
    const [subcategoryList, setSubcategoryList] = useState([]);
    const [isOnShowFabricStyleSubGnb, setIsOnShowFabricStyleSubGnb] = useState(false);
    const [videoUrlList, setVideoUrlList] = useState([]);
    const [isShowContactPopup, setIsShowContactPopup] = useState(false);
    const [isOnShowMobileGnb, setIsOnShowMobileGnb] = useState(false);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(_ => {
        console.log('props.containerClassName', props.containerClassName);
        const videoUrlList = JSON.parse(JSON.stringify(VIDEOS[props.containerClassName]));
        console.log('windowDimensions', windowDimensions);
        setVideoUrlList(videoUrlList);

        if (containerClassName.indexOf('main') >= 0) {
            setMenuIdx(0);
            setMainImageUrl(MAIN_IMG_LIST[0]);
        } else if (containerClassName.indexOf('about') >= 0) {
            setMenuIdx(1);
            setMainImageUrl(MAIN_IMG_LIST[1]);
        } else if (containerClassName.indexOf('style') >= 0) {
            setMenuIdx(2);
            setMainImageUrl(MAIN_IMG_LIST[2]);
        } else if (containerClassName.indexOf('story') >= 0
            || containerClassName.indexOf('stories') >= 0
            || containerClassName.indexOf('news') >= 0) {
            setMenuIdx(3)
            setMainImageUrl(MAIN_IMG_LIST[3]);
        } else if (containerClassName.indexOf('new-material') >= 0
            || containerClassName.indexOf('production') >= 0) {
            setMenuIdx(4)
            setMainImageUrl(MAIN_IMG_LIST[4]);
        }

        setSubcategoryList(AppData.getChildCategoryList()[selectedCategoryCode]);

        window.addEventListener('resize', onResizeWindow)

        return (_ => {
            window.removeEventListener('resize', onResizeWindow);
        });
    }, [props]);

    const onResizeWindow = _ => {
        setWindowDimensions(getWindowDimensions());
    }

    const onClickBtnHamburger = evt => {
        console.log('onClickBtnHamburger');
        toggleMobileGnb(true);
    }
    const onClickBtnCloseMobileGnb = evt => {
        toggleMobileGnb(false);
    }

    const onClickGnbFabricStyle = (categoryCode = null) => {
        console.log('categoryCode', categoryCode);
        if (categoryCode) {
            setSelectedCategoryCode(categoryCode);
            setSubcategoryList(AppData.getChildCategoryList()[categoryCode]);
        }
        setIsOnShowFabricStyleSubGnb(true);
        toggleMobileGnb(false);
    }
    const onClickBtnCategory = categoryInfo => {
        setIsOnShowFabricStyleSubGnb(false);
        props.history.push(`/style-fabric?categoryCode=${categoryInfo.code}`);
        document.body.style.position = 'relative';
        document.body.style.overflow = 'auto';
    }

    const onClickBtnCloseStyleFabricCategoryMenu = evt => {
        setIsOnShowFabricStyleSubGnb(false);
        document.body.style.position = 'relative';
        document.body.style.overflow = 'auto';
    }

    const onClickBtnContact = evt => {
        console.log('onClickBtnContact')
        setIsShowContactPopup(true);
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'hidden';
    }

    const onClickBtnCloseContactPopup = evt => {
        console.log('onClickBtnCloseContactPopup')
        setIsShowContactPopup(false);
        document.body.style.position = 'relative';
        document.body.style.overflow = 'auto';
    }

    const setCategory = categoryCode => {
        setSelectedCategoryCode(categoryCode);
        setSubcategoryList(AppData.getChildCategoryList()[categoryCode]);
    }

    const onClickBtnAbout = evt => {
        toggleMobileGnb(false);
        props.history.push('/about/introduction')
    }
    const onClickBtnStyleAndFabric = evt => {
        toggleMobileGnb(false);
        setIsOnShowFabricStyleSubGnb(true);
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'hidden';
    }
    const onClickBtnStoriesAndNews = evt => {
        toggleMobileGnb(false);
        props.history.push('/stories-news');
    }
    const onClickBtnNewMaterialAndProduction = evt => {
        toggleMobileGnb(false);
        props.history.push('/new-material-production');
    }

    const toggleMobileGnb = isShow => {
        setIsOnShowMobileGnb(isShow);
        if (isShow) {
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.position = 'relative';
            document.body.style.overflow = 'auto';
        }
    }

    const gotoMain = evt => {
        props.history.push('/');
    }

    return (
        <div id='container' className={`${containerClassName} ${isTest ? 'test' : ''}`}>
            <div
                onClick={gotoMain}
                className="logo"><i></i></div>
            <div className='btn-hamburger'
                onClick={onClickBtnHamburger}><i></i></div>
            <StyleFabricCategoryComponent
                isOnShowFabricStyleSubGnb={isOnShowFabricStyleSubGnb}
                onClickBtnCloseStyleFabricCategoryMenu={onClickBtnCloseStyleFabricCategoryMenu}
                onClickBtnCategory={onClickBtnCategory}
                selectedCategoryCode={selectedCategoryCode}
                subcategoryList={subcategoryList}
                setCategory={setCategory}
                {...props} />
            <VideoLayoutComponent
                gotoMain={gotoMain}
                videoUrlList={videoUrlList}
                mainImageUrl={mainImageUrl}
                windowDimensions={windowDimensions}
                {...props} />
            <div className='content'>
                <GnbLayoutComponent
                    onClickBtnCloseMobileGnb={onClickBtnCloseMobileGnb}
                    toggleMobileGnb={toggleMobileGnb}
                    isOnShowMobileGnb={isOnShowMobileGnb}
                    menuIdx={menuIdx}
                    containerClassName={containerClassName}
                    onClickGnbFabricStyle={onClickGnbFabricStyle}
                    onClickBtnContact={onClickBtnContact}
                    onClickBtnAbout={onClickBtnAbout}
                    onClickBtnStyleAndFabric={onClickBtnStyleAndFabric}
                    onClickBtnStoriesAndNews={onClickBtnStoriesAndNews}
                    onClickBtnNewMaterialAndProduction={onClickBtnNewMaterialAndProduction}
                    {...props} />
                {children}
            </div>
            <a onClick={onClickBtnContact} className='btn-contact'>
                <i></i>
            </a>
            <a href='#' className='btn-top'>
                <i></i>
            </a>
            <ContactUsPopupContainer
                isShowContactPopup={isShowContactPopup}
                onClickBtnCloseContactPopup={onClickBtnCloseContactPopup}
            />
        </div>
    )
}

export default withRouter(LayoutComponent);